






import { defineComponent } from '@vue/composition-api';
import { useModelstatistics } from '@/use';

export default defineComponent({
  name: 'DevModelStatisticsMenu',
  components: {},
  setup() {
    const { statisticsJson } = useModelstatistics();

    return { statisticsJson };
  },
});
